// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__1IfIg","label":"TextInput_label__m4XF7"};